import { Step } from 'signup-constants/Step';
export let CopyKey;
(function (CopyKey) {
  CopyKey["default"] = "default";
  CopyKey["Loading"] = "loading";
  CopyKey["Analyzing"] = "analyzing";
  CopyKey["FoundAllInfo"] = "foundAllInfo";
  CopyKey["FoundTwoInfo"] = "foundTwoInfo";
  CopyKey["FoundOneInfo"] = "foundOneInfo";
  CopyKey["NoInfo"] = "noInfo";
})(CopyKey || (CopyKey = {}));
const translationKeyPrefix = `views.${Step.CompanyDomain}.gtkmHelperText`;
export const gtkmDomainHelperTextConfig = {
  [CopyKey.default]: ``,
  [CopyKey.Loading]: `${translationKeyPrefix}.loading`,
  [CopyKey.Analyzing]: `${translationKeyPrefix}.analyzing`,
  [CopyKey.FoundAllInfo]: `${translationKeyPrefix}.foundAllInfo`,
  [CopyKey.FoundTwoInfo]: `${translationKeyPrefix}.foundTwoInfo`,
  [CopyKey.FoundOneInfo]: `${translationKeyPrefix}.foundOneInfo`,
  [CopyKey.NoInfo]: `${translationKeyPrefix}.noInfo`
};